import {Component, input, InputSignal, model, ModelSignal} from '@angular/core';
import {PrintInventaireService} from '../../../../core/services/gestion-stock/print-inventaire.service';
import {SearchSupplierWrapper} from '../../../../core/suppliers/wrappers/search-supplier-wrapper';
import {saveAs} from 'file-saver';
import {PrintOptionInventaire} from '../../../../core/models/gestion-stock/print-inventaire.model';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {DxCheckBoxModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from '../../../../shared/shared.module';

export enum PrintOption {
  detailsByLot = 'detailsByLot',
  detailsAccounting = 'detailsAccounting',
  showQuantite = 'showQuantite',
  hideEmpty = 'hideEmpty'
}

@Component({
  selector: 'yo-dialog-print-inventaire',
  templateUrl: './dialog-print-inventaire.component.html',
  styleUrls: ['./dialog-print-inventaire.component.scss'],
  standalone: true,
  imports: [
    DxPopupModule,
    DxCheckBoxModule,
    SharedModule
  ]
})
export class DialogPrintInventaireComponent {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  public searchSupplierWrapper: InputSignal<SearchSupplierWrapper> = input<SearchSupplierWrapper>();
  public displayDialog: ModelSignal<boolean> = model<boolean>(false);

  public detailsByLot = false;
  public detailsAccounting = false;
  public showQuantite = false;
  public hideEmpty = true;

  constructor(private printInventaireService: PrintInventaireService) {}

  onClose() {
    this.displayDialog.set(false);
  }

  extractInventaire(printMode: boolean) {
    const printOptionList: string[] = [];
    if (this.hideEmpty) printOptionList.push(PrintOption.hideEmpty);
    if (this.detailsAccounting) printOptionList.push(PrintOption.detailsAccounting);
    if (this.detailsByLot) printOptionList.push(PrintOption.detailsByLot);
    if (this.showQuantite) printOptionList.push(PrintOption.showQuantite);

    const printOptionInventaire: PrintOptionInventaire = {
      searchSupplierWrapper: this.searchSupplierWrapper(),
      printOptions: printOptionList
    };

    this.printInventaireService.extractInventaire(printOptionInventaire, printMode).subscribe(response => {
      const blob = printMode
        ? new Blob([response], {type: 'application/pdf'})
        : new Blob([response], {type: 'application/vnd.ms-excel'});
      const titleFile = printMode
        ? `inventaire-${new Date().getTime()}.pdf`
        : `inventaire-${new Date().getTime()}.xlsx`;
      saveAs(blob, titleFile);
    });
    this.onClose();
  }
}
